export const CATALOG = {
    CATALOG_LIST: "catalog-list",
    CREATE_NEW_BTN: "create-new-btn",
    PRODUCT_TILE: "item-tile",
    BULK_ADD_BTN: "bulk-add-btn",
    SELECT_ALL_CHECKBOX: "select-all-box",
    ADD_ITEM_FAB: "add-item-fab",
    ITEMS_PANEL: "items-panel",
    DELIVERY_SELECTOR: "delivery-selector",
    DELIVERY_OPTION: "delivery-option",
    VIEW_SETTINGS_LINK: "view-settings-link",
    GROUP_ITEM_CHECKBOX: "group_item_checkbox",
    ONLY_PREBOOK_PRODUCTS_TOGGLE: "only-prebook-products",
    VISIBLE_AFTER_EXPIRED_TOGGLE: "visible-after-expired",
    ACTIVE_TOGGLE: "active-toggle",
    DELIVERY_START_PICKER: "delivery-start-picker",
    DELIVERY_END_PICKER: "delivery-end-picker",
    CATALOG_SUMMARY: "catalog_summary",
    DESCRIPTION_INPUT: "description-input",
    DELIVERY_TOOLTIP: "delivery-tooltip",
    VISIBILITY_TOOLTIP: "visibility-tooltip",
    EXPIRED_WARNING: "expired-warning",
    DELIVERY_LABEL: "delivery-label",
    DELIVERY_LABEL_TOOLTIP: "delivery-label-tooltip",
    DELIVERY_DATES: "delivery-dates",
    VISIBLE_CURRENCIES: "visible-currencies",
    VISIBLE_WAREHOUSES: "visible-warehouses",
    VISIBLE_CURRENCIES_SELECTOR: "visible-currencies-selector",
    VISIBLE_WAREHOUSES_SELECTOR: "visible-warehouses-selector",
    ALLOWED_CUSTOMER_GROUPS_SELECTOR: "allowed-customer-groups-selector",
    ALLOWED_CUSTOMER_GROUPS: "allowed-customer-groups",
    ALLOWED_SUBTEAMS_SELECTOR: "allowed-subteams-selector",
    ALLOWED_SUBTEAMS: "allowed-subteams",
    SAVE_SETTINGS_BTN: "settings-done-btn",
    DELIVERY_WINDOW_FORM: "delivery-window-form",
    TOGGLE_CONTAINER: "toggle-container",
    RESTRICTIONS_CONTAINER: "catalog-restrictions",
    ACTIONS_MENU_BUTTON: "actions-menu-btn",
    ACTION_COPY_LINK: "action-copy-link",
    ACTION_DELETE: "action-delete",
    ACTION_EXPORT: "action-export",
    SEARCH_ITEMS: "search-items",
    PANEL_ADD_NOTES_BTN: "panel-add-notes-btn",
    CARD_ADD_NOTES_BTN: "card-add-notes-btn",
    ITEM_PANEL_NOTES_INPUT: "item-panel-notes-input",
    DIALOG_NOTES_INPUT: "dialog-notes-input",
    CATALOG_VIEW_NOTES: "catalog-view-notes",
    ENTER_LINK_INPUT: "enter-link-input",
    ENTER_LINK_LABEL_INPUT: "enter-link-label-input",
    ADD_LINK: "add-link",
    DELETE_LINK: "delete-link",
    CUSTOM_EXTERNAL_LINK: "custom-external-link",
    DOWNLOAD_ACTION_BUTTON: "download-action",
    CATALOG_DOWNLOAD_BUTTON: "download-catalog",
    TEMPLATE: {
        LANDSCAPE_SINGLE_16: "landscape_single_16",
        LANDSCAPE_SINGLE_5: "landscape_5",
        LANDSCAPE_SINGLE_4: "landscape_single_4",
        LANDSCAPE_SINGLE_4_I: "landscape_single_4i",
        PORTRAIT_4: "portrait_4",
        LANDSCAPE_8: "landscape_8",
        LANDSCAPE_2: "landscape_2",
        LANDSCAPE_2_I: "landscape_2i",
        COLOR_CARD: "template-color-card",
        COLOR_SWATCH: "template-color-swatch",
        BARCODE: "template-barcode",
        INVENTORY_BY_SIZE: "template-inventory-by-size",
        TOTAL_INVENTORY: "template-total-inventory",
        INCLUDE_PRODUCT_BANNERS: "template-include-product-banners",
    },
    DOWNLOAD_CATALOG: "download-catalog",
    DOWNLOAD_ACTION: "download-action",
    OPTION_PDF: "option-pdf",
    OPTION_XLSX: "option-xlsx",
    OPTION_ATS: "option-ats",
    SEND_CATALOG: "send-catalog",
    PDF_TEMPLATE_DROPDOWN: "pdf-template-dropdown",
    DETAILS_EDIT: "catalog-details-edit",
    SETTINGS_DIALOG: "settings-dialog",
    SETTINGS_DONE_BTN: "settings-done-btn",
    IN_CATALOG_INDICATOR: "inCatalog-indicator",
    SHOW_MSRP: "show-msrp",
    SHOW_WHOLESALE: "show-wholesale",
    DISPLAY_CATALOG: "display-catalog",
    FILTERED_PRODUCTS: "filtered-products",
    ALL_COLOR: "all-color",
    DELETE_ENTRY_FAB: "delete-entry-fab",
    ENTRY_MORE_ACTIONS: "entry-more-actions",
    CHANGE_WAREHOUSE_CANCEL: "change-warehouse-cancel",
    CHANGE_WAREHOUSE_SUBMIT: "change-warehouse-submit",
};
